<template>
  <div class="pass-index mt20">
    <el-form
      ref="form"
      :model="ruleForm2"
      :rules="rules2"
      class="demo-ruleForm2"
    >
      <el-form-item label="账号" prop="mobile">
        <el-input
          v-model="ruleForm2.mobile"
          placeholder="请输入手机号"
          maxlength="11"
          class="el-int"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" class="password mt20">
        <el-input
          v-model="ruleForm2.password"
          placeholder="请输入密码"
          class="el-int"
          type="password"
        ></el-input>
      </el-form-item>
      <el-button
        type="primary"
        :class="isAffirm ? 'register-btn isAffirm' : 'register-btn'"
        :disabled="!isAffirm"
        @click="submit(form)"
        >登录</el-button
      >
    </el-form>
    <div class="bottom">
      <div class="pas">
        <el-checkbox
          v-model="checked"
          size="large"
          class="checkbox"
        ></el-checkbox>
        <span>记住密码</span>
      </div>
      <div class="r-text" v-if="windowW > 850">
        <a @click="forgetPassword">忘记密码</a> |
        <!-- <router-link to="/forgetPassword">忘记密码</router-link>  -->
        <a @click="passRegister">注册</a>
      </div>
      <div class="r-text" v-else>
        <router-link to="/forgetPassword">忘记密码</router-link> | <router-link to="/register">注册</router-link>
        <!-- <a href="/forgetPassword">忘记密码</a>
        |
        <a href="/register">注册</a> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  reactive,
  ref,
  toRefs,
  defineComponent,
  onBeforeMount,
  watchEffect,
  inject,
} from "vue";
import { ElForm, ElMessage } from "element-plus";
import { passWordSubmit } from "@/api/login";
import { useRouter, useRoute } from "vue-router";
type FormInstance = InstanceType<typeof ElForm>;
export default defineComponent({
  name: "passwordLogin",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const form = ref<FormInstance>();
    const ruleForm2 = reactive({
      mobile: "",
      password: "",
    });
    const checked = ref<boolean>(true);
    const formRoute = localStorage.getItem("formRoute"); //获取上一页路径
    const isAffirm = ref(false);
    onBeforeMount(() => {
      ruleForm2.mobile = localStorage.getItem("mobile")
        ? (localStorage.getItem("mobile") as string)
        : "";
      ruleForm2.password = localStorage.getItem("password")
        ? (localStorage.getItem("password") as string)
        : "";
    });

    const vaildateMobile = (rule: any, value: any, callback: any) => {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const rules2 = reactive({
      mobile: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "blur",
        },
        { validator: vaildateMobile, trigger: "change" },
      ],
      password: [
        {
          required: true,
          message: "请输入密码",
          trigger: "blur",
        },
      ],
    });

    const submit = (formEl: FormInstance | undefined): void => {
      (formEl as any).validate((valid: any) => {
        if (valid) {
          passWordSubmit(ruleForm2).then((res: any) => {
            if (res.code == 0) {
              if (checked.value) {
                localStorage.setItem("mobile", ruleForm2.mobile);
                localStorage.setItem("password", ruleForm2.password);
              }
              ElMessage.success("登录成功！");

              localStorage.setItem("userInfo", JSON.stringify(res.data.info));
              localStorage.setItem(
                "authorization",
                res.data.info.authorization
              );
              localStorage.setItem("expirationTime", res.data.info.ex_time);
              if (windowW > 850) {
                location.reload();
              } else {
                if (
                  location.origin == "https://pay2.diancang.site" ||
                  location.origin == "https://zhishiquan.online"
                ) {
                  console.log("formRoute", formRoute);
                  if (formRoute) {
                    // router.push({path:route.query.path as string,query:{id:route.query.id}})
                    location.href =
                      location.origin + "/official-web" + formRoute;
                  } else {
                    location.href = "/official-web/";
                  }
                } else {
                  // router.push({path:route.query.path as string,query:{id:route.query.id}})
                  if (formRoute) {
                    location.href = location.origin + formRoute;
                  } else {
                    location.href = "/";
                  }
                }
              }
            }
          });
        }
      });
    };

    const myInject: any = inject("passRegister");
    const passRegister = () => {
      myInject("passRegister");
      console.log("dsdsd");
    };

    const forpaInject: any = inject("forgetPassword");
    const forgetPassword = () => {
      forpaInject("forgetPassword");
    };

    watchEffect(() => {
      if (ruleForm2.mobile.length == 11 && ruleForm2.password.length > 5) {
        isAffirm.value = true;
      } else {
        isAffirm.value = false;
      }
    });
    // 判断是pc端还是移动端
    const windowW = window.innerWidth;
    return {
      windowW,
      ruleForm2,
      form,
      rules2,
      checked,
      submit,
      passRegister,
      isAffirm,
      forgetPassword,
    };
  },
});
</script>
<style lang="less">
@import url("@/assets/styles/login.less");
.checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ffca28;
  border-color: #ffca28;
}
.checkbox .el-checkbox__inner:hover {
  border-color: #ffca28;
}
</style>
<style lang="less" scoped>
@import url("@/assets/styles/common.less");
.pass-index {
  .register-btn {
    border: none;
    .boxSize(100%,40px);
    background: #f1f1f1;
    .font(#D1D2D5,16px);
    &:hover {
      background: #f1f1f1;
      .font(#D1D2D5,16px);
    }
    &.isAffirm {
      background: #ffca28;
      color: #333333;
      &:hover {
        background: #ffca28;
        color: #333333;
      }
    }
  }
  .bottom {
    .Flex(space-between,center);
    height: 20px;
    .pas {
      .font(#333333,14px);
      span {
        .Position(relative,5px,-2px);
      }
    }
    .r-text {
      // .pointer();
      .font(#999999,14px);
      a {
        color: #999999;
      }
    }
  }
}
@media only screen and (max-width: 850px) {
  .pass-index {
    padding-top: 0.5rem;
    .register-btn {
      margin-top: 0.4rem;
      margin-bottom: 0.3rem;
    }
  }
  .password {
    margin-top: 16px !important;
    margin-bottom: 16px;
  }
}
</style>